import 'react-popper-tooltip/dist/styles.css';

import { FC, ReactElement } from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';

import { ElementWrapperStyled, TooltipContentStyled } from './Tooltip.styled';

type TriggerT = 'hover' | 'click';
type StrategyT = 'fixed' | 'absolute';

type TooltipPropsT = {
  element: ReactElement;
  trigger?: TriggerT[];
  strategy?: StrategyT;
  interactive?: boolean;
};

const Tooltip: FC<TooltipPropsT> = ({
  element,
  children,
  interactive = false,
  trigger = ['hover'],
  strategy = 'absolute',
}) => {
  const { visible, setTriggerRef, setTooltipRef, getTooltipProps } = usePopperTooltip(
    {
      trigger,
      interactive,
    },
    {
      strategy,
    }
  );

  return (
    <>
      <ElementWrapperStyled ref={setTriggerRef}>{element}</ElementWrapperStyled>
      {visible && (
        <TooltipContentStyled
          ref={setTooltipRef}
          {...getTooltipProps({ className: 'tooltip-container' })}
        >
          {children}
        </TooltipContentStyled>
      )}
    </>
  );
};

export default Tooltip;
